/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageEmpty: {
  name: 'bubble-message-empty';
  data: string;
} = {
  name: 'bubble-message-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8.277l-4.762 2.858A1 1 0 0 1 2 21V5Zm18 0H4v14.234l3.248-1.949A2 2 0 0 1 8.277 17H20V5Z" fill="currentColor"/></svg>`,
};
